"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.filterLinksByFeatureFlag = void 0;
exports.transformTree = transformTree;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/filter"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/keys"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));
const filterLinksByFeatureFlag = (links, featureFlags) => {
  return (0, _map.default)(links).call(links, link => {
    if (link.links) {
      var _context;
      link.links = (0, _filter.default)(_context = link.links).call(_context, element => {
        const featureFlagKey = (0, _keys.default)(element.featureFlag || {})[0];
        if (!element.featureFlag) {
          return true;
        }
        return featureFlags[featureFlagKey] && element.featureFlag[featureFlagKey];
      });
    }
    return link;
  });
};
exports.filterLinksByFeatureFlag = filterLinksByFeatureFlag;
function transformTree(menuTreeData) {
  var _context2;
  const links = [];
  (0, _forEach.default)(_context2 = menuTreeData.treeStructure).call(_context2, treeItem => {
    const link = {
      text: treeItem.menuItem.text,
      href: treeItem.menuItem.url,
      links: []
    };
    if (treeItem.children) {
      var _context3;
      link.links = (0, _map.default)(_context3 = treeItem.children).call(_context3, child => {
        return {
          text: child.menuItem.text,
          href: child.menuItem.url,
          badge: child.menuItem.badge ? child.menuItem.badge.text : undefined,
          badgeType: child.menuItem.badge ? child.menuItem.badge.color : undefined
        };
      });
    }
    links.push(link);
  });
  return links;
}